/**
 * 新版国际化系统翻译插件
 */

 function createTrans() {
    let dict = {};
    try {
        if (KSC_SECNET_CONSOLE.LANG === 'en') {
            dict = require(`../../dicts/en.js`);
        }
        else if (KSC_SECNET_CONSOLE.LANG === 'ko') {
            dict = require(`../../dicts/ko.js`);
        }
    } catch(e) {
        console.log('createTrans',e);
    }

    window.ksc_i18n_dict = window.ksc_i18n_dict || {};
    Object.assign(window.ksc_i18n_dict, dict);

    function trans(key) {
        // 兼容老系统的拼音key，拼音key需要查词典
        if (!KSC_SECNET_CONSOLE || !KSC_SECNET_CONSOLE.LANG || (KSC_SECNET_CONSOLE.LANG === 'zh' && /[\u4e00-\u9fa5]/.test(key) && !/{\d}/.test(key)) ) {
            return key.split('@desc=')[0];
        }

        // 为没有注明词性的设定为名词
        let content = window.ksc_i18n_dict[key+'@desc=n'] || window.ksc_i18n_dict[key] || key;

        let args = Array.prototype.slice.call(arguments, 1)
        const helperRegex = /{\d}/g;
        if (helperRegex.test(content)) {
            content = content.replace(helperRegex, function(helper) {
                let helperIdx = helper.replace(/{|}/g, '');
                return args[helperIdx];
            });
        }

        return content || key.split('@desc=')[0];
    };

    return trans;
}

const VueTransPlugin = {
    install: function(Vue) {
        let trans = createTrans();
        Vue.$trans = trans;
        Vue.prototype.$trans = trans;
    }
};
const $trans = createTrans();

export {
    createTrans,
    VueTransPlugin,
    $trans
};